<script lang="ts">
    import {
        VpCalendarIcon,
        VpChevronRightIcon,
        VpMapPinIcon,
        VpWalkIcon,
    } from '@decathlon-experience/icons/svelte';
    import { melt } from '@melt-ui/svelte';

    import { trans } from '$assets/shop-translator.js';
    import alpine_skiing from '$saga/icons/sports/alpine_skiing.svg';
    import hiking from '$saga/icons/sports/hiking.svg';
    import surf from '$saga/icons/sports/surf.svg';
    import { filtersContext } from '$saga/views/Search/store';
    import { FilterType } from '$saga/views/Search/types';

    export let trigger, handleSelectedFilter;
</script>

<div
    class="absolute bottom-[20%] left-0 z-10 mx-l flex w-[calc(100%_-_40px)] flex-col items-center justify-center gap-xs rounded-[12px] border border-solid border-border-quiet bg-white p-m desktop:hidden"
>
    <div class="flex w-full flex-col gap-xs">
        <div class="w-full bg-container-quiet px-m py-xs">
            <div class="mb-xs flex items-center gap-xs">
                <VpWalkIcon size={16} />
                <span class="font-semibold">{trans('search.bar.sport')}</span>
            </div>
            <div class="flex justify-evenly sm:justify-start sm:gap-2xl">
                <div
                    class="flex flex-1 flex-col items-center gap-2xs sm:flex-initial"
                >
                    <button
                        on:click|preventDefault|stopPropagation={() => {
                            handleSelectedFilter(FilterType.SPORT);
                            const sport =
                                $filtersContext?.defaultSportOptions?.find(
                                    (sportOption) => sportOption.value === '5', // Randonnée
                                );
                            if (sport) {
                                $filtersContext.formValues.theme = [
                                    sport.value,
                                ];
                                $filtersContext.formLabels.theme = [
                                    sport.label,
                                ];
                            }
                        }}
                        {...$trigger}
                        use:trigger
                        class="flex h-fit w-fit items-center justify-center rounded-[12px] bg-white p-xs shadow-light"
                    >
                        <img
                            src={hiking}
                            alt={trans('search.bar.hiking')}
                            class="size-3xl"
                        />
                    </button>
                    <span class="text-center text-xs"
                        >{trans('search.bar.hiking')}</span
                    >
                </div>
                <div
                    class="flex flex-1 flex-col items-center gap-2xs sm:flex-initial"
                >
                    <button
                        on:click|preventDefault|stopPropagation={() => {
                            handleSelectedFilter(FilterType.SPORT);
                            const sport =
                                $filtersContext?.defaultSportOptions?.find(
                                    (sportOption) => sportOption.value === '23', // surf
                                );
                            if (sport) {
                                $filtersContext.formValues.theme = [
                                    sport.value,
                                ];
                                $filtersContext.formLabels.theme = [
                                    sport.label,
                                ];
                            }
                        }}
                        {...$trigger}
                        use:trigger
                        class="flex h-fit w-fit items-center justify-center rounded-[12px] bg-white p-xs shadow-light"
                    >
                        <img
                            src={surf}
                            alt={trans('search.bar.surf')}
                            class="size-3xl"
                        />
                    </button>
                    <span class="text-center text-xs"
                        >{trans('search.bar.surf')}</span
                    >
                </div>
                <div
                    class="flex flex-1 flex-col items-center gap-2xs sm:flex-initial"
                >
                    <button
                        on:click|preventDefault|stopPropagation={() => {
                            handleSelectedFilter(FilterType.SPORT);
                            const sport =
                                $filtersContext?.defaultSportOptions?.find(
                                    (sportOption) => sportOption.value === '30', // ski alpin
                                );
                            if (sport) {
                                $filtersContext.formValues.theme = [
                                    sport.value,
                                ];
                                $filtersContext.formLabels.theme = [
                                    sport.label,
                                ];
                            }
                        }}
                        {...$trigger}
                        use:trigger
                        class="flex h-fit w-fit items-center justify-center rounded-[12px] bg-white p-xs shadow-light"
                    >
                        <img
                            src={alpine_skiing}
                            alt={trans('search.bar.alpine_skiing')}
                            class="size-3xl"
                        />
                    </button>
                    <span class="text-center text-xs"
                        >{trans('search.bar.alpine_skiing')}</span
                    >
                </div>
                <div
                    class="flex flex-1 flex-col items-center gap-2xs sm:flex-initial"
                >
                    <button
                        on:click|preventDefault|stopPropagation={() => {
                            handleSelectedFilter(FilterType.SPORT);
                        }}
                        {...$trigger}
                        use:trigger
                        class="flex h-fit w-fit items-center justify-center rounded-[12px] bg-white p-xs shadow-light"
                    >
                        <span class="h-3xl w-3xl text-[28px] font-semibold"
                            >...</span
                        >
                    </button>
                    <span class="text-center text-xs"
                        >{trans('search.bar.other_sport')}</span
                    >
                </div>
            </div>
        </div>
        <button
            on:click|preventDefault|stopPropagation={() => {
                handleSelectedFilter(FilterType.DESTINATION);
            }}
            {...$trigger}
            use:trigger
            class="w-full bg-container-quiet px-m py-xs"
        >
            <span class="flex items-center gap-xs">
                <VpMapPinIcon size={16} />
                <span class="font-semibold"
                    >{trans('search.bar.destination')}</span
                >
                <VpChevronRightIcon size={16} class="ml-auto" />
            </span>
        </button>
        <button
            on:click|preventDefault|stopPropagation={() => {
                handleSelectedFilter(FilterType.STARTDATE);
            }}
            {...$trigger}
            use:trigger
            class="w-full bg-container-quiet px-m py-xs"
        >
            <span class="flex items-center gap-xs">
                <VpCalendarIcon size={16} />
                <span class="font-semibold"
                    >{trans('search.bar.departure_dates')}</span
                >
                <VpChevronRightIcon size={16} class="ml-auto" />
            </span>
        </button>
    </div>
    <button
        class="vp-button vp-button-small vp-button--squared w-full normal-case"
        use:melt={$trigger}
    >
        <span class="flex items-center gap-xs"
            >{trans('search.bar.search_trip')}</span
        >
    </button>
</div>
